import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/getting-involved.css';
import config from '../config';

const GettingInvolvedPage = () => {
    return (
        <div className="container py-5">
            <header className="getting-involved-hero">
                <h1 className="display-4 getting-involved-title">Get Involved</h1>
                <p className="getting-involved-intro">
                    The Electrospinning Data project welcomes contributions from researchers and developers.
                    You can share datasets, improve the platform, or provide feedback.
                </p>
            </header>

            <section className="involvement-grid">
                {/* Contribute Data Card */}
                <div className="involvement-card">
                    <div className="card-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                            <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                        </svg>
                    </div>
                    <h3 className="card-title">Contribute Data</h3>
                    <p className="card-text">
                        Submit electrospinning datasets from published studies to expand the platform dataset.
                    </p>
                    <Link to="/dataSubmission" className="btn btn-primary px-4">Submit Data</Link>
                </div>

                {/* Contribute Code Card */}
                <div className="involvement-card">
                    <div className="card-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294l4-13zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0zm6.292 0a.5.5 0 0 1 .708 0l3.5 3.5a.5.5 0 0 1 0 .708l-3.5 3.5a.5.5 0 0 1-.708-.708L14.293 8l-3.147-3.146a.5.5 0 0 1 0-.708z" />
                        </svg>
                    </div>
                    <h3 className="card-title">Contribute Code</h3>
                    <p className="card-text">
                        Contribute to the platform development through our GitHub repository. Issues and pull requests are welcome.
                    </p>
                    <a
                        href={config.githubUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-primary px-4"
                    >
                        View Repository
                    </a>
                </div>

                {/* Feedback & Collaboration Card */}
                <div className="involvement-card">
                    <div className="card-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M2.938 6.854a.5.5 0 0 0-.426 1.146l3.25 1.218a.5.5 0 0 0 .346-.03l6.25-3.085a.5.5 0 0 0 .19-.613l-1.579-3.219a.5.5 0 0 0-.776-.145L5.756 5.862 2.938 6.854zm9.328-3.414 1.258 2.565-5.36 2.645-3.805-1.427 4.167-3.6 3.74 2.817z" />
                            <path fillRule="evenodd" d="M3.5 10a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9z" />
                        </svg>
                    </div>
                    <h3 className="card-title">Feedback</h3>
                    <p className="card-text">
                        Report issues, suggest improvements, or share ideas. Institutional collaborations are also welcome.
                    </p>
                    <Link to="/contact" className="btn btn-outline-primary px-4">Send Feedback</Link>
                </div>
            </section>

            <section className="join-community-section">
                <h2 className="mb-3" style={{ color: '#003366', fontWeight: 700 }}>Community and Contact</h2>
                <p className="join-community-text">
                    For questions, collaboration inquiries, or feedback, please get in touch.
                </p>
                <div className="d-flex justify-content-center gap-3">
                    <Link to="/contact" className="btn btn-primary px-4 py-2">Contact</Link>
                </div>
            </section>
        </div>
    );
};

export default GettingInvolvedPage;
